<template>
  <div class="invalido">
    <h1>Contrato não encontrado</h1>
    <p>O link acessado não pode ser encontrado ou o período do preenchimento expirou.</p>
  </div>
</template>

<script>
export default {
  name: 'contratoInvalido'
}
</script>
